import React from "react";

const Row = props => (
  <div className="row">
    {props.children}
  </div>
);

export default Row;



// WEBPACK FOOTER //
// ./src/components/Row.js